<template>
	<nav class="green">
		<div class="container">
			<div class="nav-wrapper">
				<router-link :to="{ name: 'Index' }" class="brand-logo left hide-on-small-only">To-Do App</router-link>
				<ul class="right">
					<li>
						<router-link :to="{ name: 'Index' }">Home</router-link>
					</li>

					<div v-if="!loggedIn" style="display: inline">
						<li>
							<router-link :to="{ name: 'Login' }">Login</router-link>
						</li>
						<li>
							<router-link :to="{ name: 'Signup' }">Sign up</router-link>
						</li>
					</div>
					<li v-else>
						<a @click="logout">Logout ({{ username }})</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'

export default {
	name: "Navbar",
	data() {
		return {
			loggedIn: false,
			username: null
		}
	},
	methods: {
		logout() {
			firebase.auth().signOut()
				.then(() => {
					if (this.$route != { name: "Index" }) this.$router.push({ name: "Index" })
				})
				.catch(err => console.error(err))
		}
	},
	created() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.loggedIn = user ? true : false

				db.collection("users").get()
					.then(snapshot => {
						snapshot.forEach(doc => {
							if (doc.data().user_uid == user.uid)
								this.username = doc.data().username
						})
					})
					.catch(err => console.error(err))
			}
		})
	}
}
</script>

<style>
nav .container {
	max-width: 600px;
}
nav .nav-wrapper {
	margin: 0 20px 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/navigation/Navbar.vue